export { PortalHost as AlertDialogPortalHost } from "@rn-primitives/portal";

/**
 * Portal host name for alert dialogs opened from INSIDE a surface that marks itself
 * `accessibilityViewIsModal` (today: the help/support bottom sheet).
 *
 * By default `AlertDialogContent` portals to the app-root host, which puts the dialog beside the
 * modal surface rather than inside it. Android's accessibility tree then hides it — the same
 * sibling-of-a-modal rule `toolbar-popover-button.test.tsx` documents for the popover backdrop —
 * so the dialog is on screen but invisible to TalkBack and to uiautomator.
 *
 * Run 35744282332 shard 3 captured exactly that: the sheet rendered with its "Reset onboarding"
 * row, the confirm dialog's "Reset onboarding?" title was absent from the hierarchy entirely, and
 * `onboarding.yaml` timed out on a dialog a sighted user can see.
 *
 * Render {@link AlertDialogPortalHost} with this name INSIDE the modal subtree and pass the same
 * name as `AlertDialogContent`'s `portalHost`, so the dialog mounts within the modal region.
 */
export const MODAL_SURFACE_ALERT_DIALOG_PORTAL_HOST_NAME = "han-modal-surface-alert-dialog";
